// extracted by mini-css-extract-plugin
export default {"header":"KRAScreen_header__hj1L+","desc":"KRAScreen_desc__LpDGL","labeltext":"KRAScreen_labeltext__AzGKs","containerData":"KRAScreen_containerData__ZIFg8"};